import { FC } from 'react'
import { Format } from 'services/Dates'
import { t } from 'translations'

type Props = {
  breaks: MData.PunchBreak[]
  hideReasons: boolean
}

const Breaks: FC<Props> = ({ breaks, hideReasons }) => {
  if (!Array.isArray(breaks)) return null

  return (
    <>
      {breaks.map(({ _id, start, end, name, unplanned, reason }) => {
        return (
          <div key={_id} className="mb-1 d-flex">
            <div>
              <i className="fad fa-coffee mr-2" />
            </div>
            <div className="text-nowrap">
              {end && start ? `${Format(start, { outFormat: 'time' })} - ${Format(end, { outFormat: 'time' })}` : null}
              {!end && start ? `${Format(start, { outFormat: 'time' })} - ${t('manager.punch.NOT_ENDED_YET')}` : null}
              {hideReasons ? null : <small className="text-muted d-block">{unplanned ? t('manager.punch.UNPLANNED', { reason }) : name}</small>}
            </div>
          </div>
        )
      })}
    </>
  )
}

export default Breaks
